import { ChangeDetectionStrategy, Component, effect, inject, Injector, Signal } from '@angular/core';
import { BusinessProfile, UserAccount } from '@iot-platform/models/common';
import { UserPreferencesFormDialogComponent } from '../../components/user-preferences-form-dialog/user-preferences-form-dialog.component';
import { UserProfileFormComponent } from '../../components/user-profile-form/user-profile-form.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthFacade } from '@iot-platform/auth';
import { ProfileFacade } from '@iot-platform/data-access/users';

@Component({
  selector: 'oyan-ui-user-profile-shell',
  templateUrl: './user-profile-shell.component.html',
  styleUrls: ['./user-profile-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UserProfileShellComponent {
  private readonly profileFacade: ProfileFacade = inject(ProfileFacade);
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly injector: Injector = inject(Injector);
  public readonly dialog: MatDialog = inject(MatDialog);

  user: Signal<UserAccount> = this.profileFacade.user;
  loading: Signal<boolean> = this.profileFacade.userLoading;
  selectedBusinessProfile: Signal<BusinessProfile> = this.authFacade.selectedBusinessProfile;

  loadUserEffect = effect(
    () => {
      if (this.selectedBusinessProfile()) {
        this.refreshUserProfile();
      }
    },
    { injector: this.injector }
  );

  refreshUserProfile(): void {
    this.profileFacade.loadUserProfile();
    this.profileFacade.loadUserPreferences();
  }

  editUserProfile() {
    this.dialog
      .open(UserProfileFormComponent, {
        width: '700px',
        disableClose: true,
        data: { user: this.user() }
      })
      .afterClosed()
      .subscribe((updatedUser: Partial<UserAccount>) => {
        if (updatedUser) {
          this.profileFacade.saveUserProfile(updatedUser);
        }
      });
  }

  changeUserPreferences(): void {
    this.dialog
      .open(UserPreferencesFormDialogComponent, {
        width: '700px',
        disableClose: true,
        data: {
          user: this.user()
        }
      })
      .afterClosed()
      .subscribe((updatedUser: Partial<UserAccount>) => {
        if (updatedUser) {
          this.profileFacade.saveUserProfile(updatedUser);
        }
      });
  }
}
